import React, { useEffect, useState } from "react";
import axios from "axios";
import Icon from "../../components/em/Icon";

import { API_URL } from '../../api/api';



const auth = () => {
  const t = localStorage.getItem('token');
  return t ? { headers: { Authorization: `Bearer ${t}` } } : {};
};
const handleAuthError = (err) => {
  if (err?.response?.status === 401) {
    localStorage.clear();
    window.location.assign('/login');
    return true;
  }
  return false;
};

const AssignShiftModal = ({ onClose, onSuccess }) => {
  const baseURL = `${API_URL}/api/settings/shifts`; 

  const [employees, setEmployees] = useState([]);
  const [shifts, setShifts] = useState([]);

  const [employee, setEmployee] = useState("");
  const [shift, setShift] = useState("");

  const [mode, setMode] = useState("single");

  const [singleDate, setSingleDate] = useState("");
  const [multiDates, setMultiDates] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [days, setDays] = useState([]);

  const weekDays = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

  useEffect(() => {
    axios
      .get(`${baseURL}/team-members`, auth())
      .then((r) => setEmployees(r.data))
      .catch(handleAuthError);
    axios
      .get(baseURL, auth())
      .then((r) => setShifts(r.data))
      .catch(handleAuthError);
  }, []);

  const toggleDay = (d) => {
    setDays(prev =>
      prev.includes(d)
        ? prev.filter(x => x !== d)
        : [...prev, d]
    );
  };
  const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  });


  const toggleMultiDate = (date) => {
    setMultiDates(prev =>
      prev.includes(date)
        ? prev.filter(d => d !== date)
        : [...prev, date]
    );
  };

  const assign = async () => {
    let payload = {
      employee_id: employee,
      shift_id: shift,
      type: mode
    };

    if (mode === "single") payload.date = singleDate;
    if (mode === "multiple") payload.dates = multiDates;
    if (mode === "recurring") {
      payload.start_date = startDate;
      payload.end_date = endDate;
      payload.days = days;
    }

    try {
      await axios.post(`${baseURL}/assign`, payload, auth());
      onSuccess();
      onClose();
    } catch (err) {
      if (handleAuthError(err)) return;
      alert(err?.response?.data?.error || 'Could not assign shift.');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">

        {/* Header */}
        <div className="title-btns">
          <div className="icn-subtit">
            <span className="icon-wrap"><Icon name="plus" /></span>
            <h3>Assign Shift</h3>
            <p>Assign a shift to an employee for specific dates</p>
          </div>
        </div>

        {/* Mode Switch */}
        <ul className="mode-tabs">
          {["single","multiple","recurring"].map(m => (
            <li
              key={m}
              className={mode===m ? "active" : ""}
              onClick={()=>setMode(m)}
            >
              {m === "single" && "Single Date"}
              {m === "multiple" && "Multiple Dates"}
              {m === "recurring" && "Recurring"}
            </li>
          ))}
        </ul>

        {/* Employee */}
        <div className="col-2">
        <div className="form-item">
          <label>Employee *</label>
          <select value={employee} onChange={e=>setEmployee(e.target.value)}>
            <option value="">Select employee</option>
            {employees.map(e=>(
              <option key={e.id} value={e.id}>
                {e.first_name} {e.last_name}
              </option>
            ))}
          </select>
        </div>

        {/* Shift */}
        <div className="form-item">
          <label>Shift *</label>
          <select value={shift} onChange={e=>setShift(e.target.value)}>
            <option value="">Select shift</option>
            {shifts.map(s=>(
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>
        </div>
        </div>

        {/* SINGLE DATE */}
        {mode==="single" && (
          <div className="form-item">
            <label>Date *</label>
            <input
              type="date"
              value={singleDate}
              onChange={e=>setSingleDate(e.target.value)}
            />
          </div>
        )}

        {/* MULTIPLE */}
        {mode==="multiple" && (
          <div className="form-item date-chips">
            <label>Select Dates *</label>
            <input
              type="date"
              onChange={e=>toggleMultiDate(e.target.value)}
            />
            <p>Click to add multiple dates for this assignment</p>

            <div className="chips">
              {multiDates.map(d=>(
                <div key={d} className="chip">
                 {formatDate(d)}
                  <span onClick={()=>toggleMultiDate(d)}>×</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* RECURRING */}
        {mode==="recurring" && (
          <div className="recurring-wrap">
            <div className="form-item day-week">
              <label>Days of Week *</label>
              <div className="weekdays">
                {weekDays.map((d,i)=>(
                  <div 
                    key={i}
                    className={days.includes(i) ? "wek active" : "wek"}
                    onClick={()=>toggleDay(i)}
                  >
                    {d}
                  </div>
                ))}
              </div>
            </div>

            <div className="date-row col-2">
              <div className="form-item">
                <label>Start Date</label>
                <input type="date" onChange={e=>setStartDate(e.target.value)}/>
              </div>
              <div className="form-item">
                <label>End Date</label>
                <input type="date" onChange={e=>setEndDate(e.target.value)}/>
              </div>
            </div>
          </div>
        )}

        {/* Footer */}
        <div className="modal-actions">
          <button className="plain-btn" onClick={onClose}>Cancel</button>
          <button onClick={assign} className="org-gradi">
            <Icon name="ok"/> Assign Shift
          </button>
        </div>

      </div>
    </div>
  );
};

export default AssignShiftModal;
